module.exports = __webpack_public_path__ + "img/UPAY会员专属回馈@2x.7d9d4ea9.png";